import { Routes } from "@angular/router";
import { LoginGuard } from './services';

import { Dashboard4Component } from "./views/dashboards/dashboard4.component";

import { LoginComponent } from "./views/account/login.component";

import { BlankLayoutComponent } from "./components/common/layouts/blankLayout.component";
import { AdminLayoutComponent } from "./components/common/layouts/adminLayout.component";
import { BasicLayoutComponent } from "./components/common/layouts/basicLayout.component";
import { Error404Component } from "./views/errors/404.component";

import { LoyaltySiteManagementTableComponent } from "./views/admin/loyalty-site/loyalty-site-management-table.component";
import { LoyaltySiteManagementComponent } from "./views/admin/loyalty-site/loyalty-site-management.component";
import { UserManagementComponent } from "./views/admin/user/user-management.component";
import { UserManagementTableComponent } from "./views/admin/user/user-management-table.component";
import { TransactionLogManagementComponent } from "./views/admin/transaction-log/transaction-log-management.component";
import { CustomerManagementComponent } from "./views/admin/customer/customer-management.component";
import { CustomerManagementTableComponent } from "./views/admin/customer/customer-management-table.component";
import { ProfileComponent } from "./views/account/profile/profile.component";
import { FraudReportsTableComponent } from "./views/admin/fraud-reports/fraud-reports-table.component";
import { FraudReportModalComponent} from "./views/admin/fraud-reports/fraud-reports-modal";
import { AuditReprotManagementComponent } from "./views/admin/audit-report/audit-report-management.component";
import { ViewCustomersGuard } from "./services/SecurityServices/view-customers.guard";
import { ViewCustomerGuard } from "./services/SecurityServices/view-customer.guard";
import { ViewUserGuard } from "./services/SecurityServices/view-user.guard";
import { ViewUsersGuard } from "./services/SecurityServices/view-users.guard";
import { ViewSitesGuard } from "./services/SecurityServices/view-sites.guard";
import { ViewSiteGuard } from "./services/SecurityServices/view-site.guard";
import { ViewLoyaltyTransactionLogsGuard } from "./services/SecurityServices/view-loyalty-transaction-logs.guard";
import { ViewLoyaltyTransactionLogGuard } from "./services/SecurityServices/view-loyalty-transaction-log.guard";
import { ViewFraudReportsGuard } from "./services/SecurityServices/view-fraud-reports.guard";
import { ViewFraudReportGuard } from "./services/SecurityServices/view-fraud-report.guard";
import { ViewCustomerMergeGuard } from "./services/SecurityServices/view-customer-merge.guard";
import { ViewAuditReportGuard } from "./services/SecurityServices/view-audit-report.guard";
import { CustomerMergeComponent } from "./views/admin/customer/customer-merge.component";
import { MapLocation } from "./views/admin/map-location/map-location.component";

export const ROUTES: Routes = [
    // Main redirect
    { path: '', redirectTo: '/admin/home', pathMatch: 'full' },

    // App views
    {
        path: 'admin', component: AdminLayoutComponent,
        children: [
            { path: '', pathMatch: 'full', redirectTo: '/admin/home' },
            { path: 'home', component: Dashboard4Component, canActivate: [LoginGuard] },
            { path: 'logout', redirectTo: '/account/login?logout=true' },
            { path: 'profile', component: ProfileComponent, canActivate: [LoginGuard] },
            { path: 'user-management/user/:id', component: UserManagementComponent, canActivate: [ViewUserGuard] },
            { path: 'user-management', component: UserManagementTableComponent, canActivate: [ViewUsersGuard] },
            { path: 'customer-management/customer/:id', component: CustomerManagementComponent, canActivate: [ViewCustomerGuard] },
            { path: 'customer-management', component: CustomerManagementTableComponent, canActivate: [ViewCustomersGuard] },
            { path: 'customer-management/customer-merge', component: CustomerMergeComponent, canActivate: [ViewCustomerMergeGuard] },
            { path: 'loyalty-site-management', component: LoyaltySiteManagementTableComponent, canActivate: [ViewSitesGuard] },
            { path: 'loyalty-site-management/loyalty-site/:id', component: LoyaltySiteManagementComponent, canActivate: [ViewSiteGuard] },
            { path: 'transaction-log-management', component: TransactionLogManagementComponent, canActivate: [ViewLoyaltyTransactionLogsGuard] },
            { path: 'transaction-log-management/:mobileNumber', component: TransactionLogManagementComponent, canActivate: [ViewLoyaltyTransactionLogGuard] },
            { path: 'fraud-reports', component: FraudReportsTableComponent, canActivate: [ViewFraudReportsGuard] },
            { path: 'fraud-reports/:mobileNumber', component: FraudReportsTableComponent, canActivate: [ViewFraudReportGuard] },
            { path: 'fraud-reports-modal', component: FraudReportModalComponent, canActivate: [ViewFraudReportGuard]},
            { path: 'audit-report', component: AuditReprotManagementComponent, canActivate: [ViewAuditReportGuard] },
            {path: 'map', component: MapLocation}
        ]
    },
    {
        path: 'client', component: BasicLayoutComponent,
        children: [
            { path: '', pathMatch: 'full', redirectTo: '/client/home' },
            { path: 'home', component: Dashboard4Component, canActivate: [LoginGuard] },
            { path: 'logout', redirectTo: '/account/login?logout=true' },
            { path: 'profile', component: ProfileComponent, canActivate: [LoginGuard] }
        ]
    },
    {
        path: 'account', component: BlankLayoutComponent,
        children: [
            { path: 'login', component: LoginComponent },
            { path: 'logout', redirectTo: '/account/login?logout=true' },
        ]
    },

    { path: '404', component: Error404Component },

    // Handle all other routes
    { path: '**', redirectTo: '/404' }
];



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/app.routes.ts